import { getElements } from "../utils.js";
import InformationDisplayRow from "./InformationDisplayRow.js";

export default function LocationCard({
  name,
  website,
  email,
  isMember,
  onMapButtonClick,
}) 
  {
    const wrapper = document.createElement("article");
    wrapper.className = "location";
    wrapper.innerHTML = `
      <div class='location__title'><span class="status ${
        !isMember ? "status--active" : ""
      }"></span> <h2>${name}<h2></div>
      <div class="information-display" data-js='information-display'>
      </div>
      <a class='location__button' href='${website}' target='_blank'><i class="fi fi-br-link-alt"></i> Zur Website</a>
      <button class='location__button' data-js='map-button'> <i class="fi fi-sr-map"></i> Auf der Karte zentrieren</button>
    `;
    const { mapButton, informationDisplay } = getElements(wrapper);

    informationDisplay.append(InformationDisplayRow("Email", email));

    mapButton.addEventListener("click", onMapButtonClick);

    return wrapper;
  }
